/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_EditInputs */

const th_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แก้ไข`)
};

const en_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit`)
};

const ja_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`編集`)
};

const zh_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑`)
};

const es_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar`)
};

const pt_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar`)
};

const id_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sunting`)
};

const fr_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier`)
};

const tl_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baguhin`)
};

const vi_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa`)
};

const ko_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수정`)
};

const de_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbeiten`)
};

const ru_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменить`)
};

const tr_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Düzenle`)
};

const it_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica`)
};

const pl_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edytuj`)
};

const uk_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Змінити`)
};

const hi_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपादित करें`)
};

const ar_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعديل`)
};

const ms_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sunting`)
};

const bn_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সম্পাদনা`)
};

const zh_tw2_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`編輯`)
};

const zh_hk2_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`編輯`)
};

const ur_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ترمیم`)
};

const fa_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ویرایش`)
};

const sw_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hariri`)
};

const nl_player_edit = /** @type {(inputs: Player_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerken`)
};

/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Player_EditInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const player_edit = /** @type {((inputs?: Player_EditInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_EditInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_player_edit(inputs)
	if (locale === "ja") return ja_player_edit(inputs)
	if (locale === "zh") return zh_player_edit(inputs)
	if (locale === "es") return es_player_edit(inputs)
	if (locale === "pt") return pt_player_edit(inputs)
	if (locale === "id") return id_player_edit(inputs)
	if (locale === "fr") return fr_player_edit(inputs)
	if (locale === "tl") return tl_player_edit(inputs)
	if (locale === "vi") return vi_player_edit(inputs)
	if (locale === "ko") return ko_player_edit(inputs)
	if (locale === "de") return de_player_edit(inputs)
	if (locale === "ru") return ru_player_edit(inputs)
	if (locale === "tr") return tr_player_edit(inputs)
	if (locale === "it") return it_player_edit(inputs)
	if (locale === "pl") return pl_player_edit(inputs)
	if (locale === "uk") return uk_player_edit(inputs)
	if (locale === "hi") return hi_player_edit(inputs)
	if (locale === "ar") return ar_player_edit(inputs)
	if (locale === "ms") return ms_player_edit(inputs)
	if (locale === "bn") return bn_player_edit(inputs)
	if (locale === "zh-TW") return zh_tw2_player_edit(inputs)
	if (locale === "zh-HK") return zh_hk2_player_edit(inputs)
	if (locale === "ur") return ur_player_edit(inputs)
	if (locale === "fa") return fa_player_edit(inputs)
	if (locale === "sw") return sw_player_edit(inputs)
	if (locale === "nl") return nl_player_edit(inputs)
	return en_player_edit(inputs)
});